import React, { useEffect, useState } from "react";
import baseUrl from "../../../../../api/baseUrl";
import { useDispatch } from "react-redux";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../redux/loader/loaderActions";
import CloseIcon from "@mui/icons-material/Close";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";

function AddTreatmentOne({ close, type }: any) {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [edit, setedit] = useState(false);
  const [error, seterror] = useState(false);
  const [errorslash, seterrorslash] = useState(false);
  const [errorOthersCase, setErrorOthersCase] = useState(false);
  const [dentists, setDentists] = useState<any[]>([]);
  const [formData, setformData] = useState({
    treatment: "",
    price: 0,
    treatmentid: "",
    type: 0,
    typeId: "",
    subId: "",
    selectedOption: "option1",
    materialCost: 0,
    doctorCommission: 0,
    doctorCommissionOverrides: [] as { dentistId: string; commission: number }[],
  });

  useEffect(() => {
    dispatch(setloadeActive());
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((response) => {
        dispatch(setloadeDeactive());
        setData(response.data.data);
      })
      .catch((error) => {
        dispatch(setloadeDeactive());
        console.log(error);
      });
  }, [dispatch]);

  const mapOverrides = (overrides: any) =>
    (Array.isArray(overrides) ? overrides : []).map((o: any) => ({
      dentistId: o.dentistId?._id || o.dentistId,
      commission: o.commission ?? 0,
    }));

  const getMain = (treatmentid: string) =>
    (data as any[]).find((x: any) => String(x._id) === String(treatmentid));

  const getType = (treatmentid: string, typeId: string) => {
    const main = getMain(treatmentid);
    return main?.type?.find((t: any) => String(t._id) === String(typeId));
  };

  const applyDefaultsFrom = (src: any) => {
    if (!src) return;
    setformData((prev) => ({
      ...prev,
      materialCost: isNaN(src.materialCost) ? prev.materialCost : (src.materialCost ?? 0),
      doctorCommission: isNaN(src.doctorCommission) ? prev.doctorCommission : (src.doctorCommission ?? 0),
      doctorCommissionOverrides: mapOverrides(src.doctorCommissionOverrides),
    }));
  };

  useEffect(() => {
    baseUrl
      .get("appointment/findAllAppointmentDentist")
      .then((response) => setDentists(response.data.data || []))
      .catch(() => setDentists([]));
  }, []);

  useEffect(() => {
    setedit(
      typeof type !== "object" ||
        (typeof type === "object" && Object.keys(type).length !== 0)
    );
    if (
      typeof type !== "object" ||
      (typeof type === "object" && Object.keys(type).length !== 0)
    ) {
      const overrides = Array.isArray(type?.doctorCommissionOverrides) ? type.doctorCommissionOverrides : [];
      if (type.type === "main") {
        setformData({
          ...formData,
          treatmentid: type?.treatmentid,
          treatment: (type?.treatment === "Others" ? "others" : type?.treatment) ?? "",
          price: type?.price,
          materialCost: isNaN(type?.materialCost) ? 0 : type?.materialCost,
          doctorCommission: isNaN(type?.doctorCommission) ? 0 : type?.doctorCommission,
          doctorCommissionOverrides: overrides.map((o: any) => ({ dentistId: o.dentistId?._id || o.dentistId, commission: o.commission ?? 0 })),
          selectedOption: "option1",
        });
      } else if (type.type === "sub") {
        setformData({
          ...formData,
          treatmentid: type?.treatmentid,
          treatment: (type?.treatment === "Others" ? "others" : type?.treatment) ?? "",
          typeId: type?.subId,
          price: type?.price,
          materialCost: isNaN(type?.materialCost) ? 0 : type?.materialCost,
          doctorCommission: isNaN(type?.doctorCommission) ? 0 : type?.doctorCommission,
          doctorCommissionOverrides: overrides.map((o: any) => ({ dentistId: o.dentistId?._id || o.dentistId, commission: o.commission ?? 0 })),
          selectedOption: "option2",
        });
      } else if (type.type === "subsub") {
        setformData({
          ...formData,
          treatmentid: type?.treatmentid,
          treatment: (type?.treatment === "Others" ? "others" : type?.treatment) ?? "",
          typeId: type?.subId,
          subId: type?.subsubId,
          price: type?.price,
          materialCost: isNaN(type?.materialCost) ? 0 : type?.materialCost,
          doctorCommission: isNaN(type?.doctorCommission) ? 0 : type?.doctorCommission,
          doctorCommissionOverrides: overrides.map((o: any) => ({ dentistId: o.dentistId?._id || o.dentistId, commission: o.commission ?? 0 })),
          selectedOption: "option3",
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sync modal `type` prop into form state; including formData would loop
  }, [type]);

  const handleChange = (e: any) => {
    if (e.target.name === "price" && formData.treatment === "others") {
      return;
    }
    // When adding Type/Subtype, prefill commission/cost from parent selection to make it easy to set different values per level
    if (!edit && (e.target.name === "treatmentid" || e.target.name === "typeId")) {
      const { name, value } = e.target;
      setformData((prev) => ({ ...prev, [name]: value }));

      // Use a microtask so state updates apply before reading dependent values
      queueMicrotask(() => {
        const nextTreatmentId = name === "treatmentid" ? value : formData.treatmentid;
        const nextTypeId = name === "typeId" ? value : formData.typeId;

        if (formData.selectedOption === "option2") {
          // Type inherits defaults from main treatment
          const main = getMain(nextTreatmentId);
          applyDefaultsFrom(main);
        } else if (formData.selectedOption === "option3") {
          // Subtype inherits defaults from selected type, fallback to main
          const t = getType(nextTreatmentId, nextTypeId);
          if (t) applyDefaultsFrom(t);
          else applyDefaultsFrom(getMain(nextTreatmentId));
        }
      });
      return;
    }
    if (e.target.name === "doctorCommission") {
      const numericValue = e.target.value.replace(/e/g, 0);
      if (/^\d{0,2}$/.test(numericValue)) {
        setformData({ ...formData, [e.target.name]: numericValue });
      }
    } else if (e.target.name.startsWith("dentistCommission_")) {
      const dentistId = e.target.name.replace("dentistCommission_", "");
      const numericValue = e.target.value === "" ? "" : e.target.value.replace(/e/g, 0);
      if (numericValue === "" || /^\d{0,3}(\.\d*)?$/.test(String(numericValue))) {
        const newOverrides = formData.doctorCommissionOverrides.filter((o) => o.dentistId !== dentistId);
        if (numericValue !== "") {
          newOverrides.push({ dentistId, commission: parseFloat(String(numericValue)) || 0 });
        }
        setformData({ ...formData, doctorCommissionOverrides: newOverrides });
      }
    } else {
      if (e.target.name === "treatment" && (e.target.value === "Others" || e.target.value === "others")) {
        const normalized = "others";
        setformData({ ...formData, [e.target.name]: normalized, price: 0 });
        setErrorOthersCase(false);
      } else if (e.target.name === "treatment" && /Others/i.test(e.target.value) && e.target.value !== "others") {
        setErrorOthersCase(true);
        setformData({ ...formData, [e.target.name]: e.target.value });
      } else {
        if (e.target.name === "treatment") setErrorOthersCase(false);
        setformData({ ...formData, [e.target.name]: e.target.value });
      }
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (formData.treatment === "") {
      seterror(true);
      return;
    }

    if (formData.treatment.includes("/")) {
      seterrorslash(true);
      return;
    }

    if (/Others/i.test(formData.treatment) && formData.treatment !== "others") {
      setErrorOthersCase(true);
      return;
    }

    const submitData = formData.treatment === "others" ? { ...formData, price: 0 } : formData;

    if (!edit) {
      if (formData?.selectedOption === "option2") {
        baseUrl
          .post("alltreatment/createTreatmentType", formData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Added type:", { treatment: formData.treatment, treatmentid: formData.treatmentid, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error));
      } else if (formData?.selectedOption === "option3") {
        baseUrl
          .post("alltreatment/createTreatmentSubType", formData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Added subtype:", { treatment: formData.treatment, typeId: formData.typeId, subId: formData.subId, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error));
      } else {
        baseUrl
          .post("alltreatment/createAllTreatment", submitData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Added treatment:", { treatment: formData.treatment, price: formData.price, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error));
      }
    } else {
      if (formData?.selectedOption === "option2") {
        baseUrl
          .patch("alltreatment/updateTreatmentType", formData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Updated type:", { treatment: formData.treatment, typeId: formData.typeId, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error.response.data));
      } else if (formData?.selectedOption === "option3") {
        baseUrl
          .patch("alltreatment/updateTreatmentSubType", formData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Updated subtype:", { treatment: formData.treatment, typeId: formData.typeId, subId: formData.subId, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error));
      } else {
        baseUrl
          .patch("alltreatment/updateAllTreatment", submitData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Updated treatment:", { treatment: formData.treatment, treatmentid: formData.treatmentid, price: formData.price, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error));
      }
    }
  };

  const radioOptions = [
    { value: "option1", label: "Treatment", id: "treatment" },
    { value: "option2", label: "Type", id: "Types" },
    { value: "option3", label: "Subtype", id: "SubTypes" },
  ];

  const commissionAmount =
    ((formData.treatment === "others" ? 0 : formData.price) - formData.materialCost) * (formData.doctorCommission / 100);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden max-h-[90vh] overflow-y-auto border border-slate-200 dark:border-slate-700">
        {/* Header */}
        <div className="px-6 py-4 bg-gradient-to-r from-primary to-primaryLight flex items-center justify-between sticky top-0">
          <div className="flex items-center gap-3">
            <MedicalServicesIcon className="text-white" sx={{ fontSize: 24 }} />
            <h2 className="text-lg font-bold text-white">
              {edit ? "Edit Treatment" : "Add Treatment"}
            </h2>
          </div>
          <button
            onClick={() => close(false)}
            className="w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="p-6 space-y-4">
            {/* Radio Options */}
            <div className="flex gap-2 p-1 bg-slate-100 dark:bg-slate-700 rounded-xl">
              {radioOptions.map((option) => (
                <label
                  key={option.value}
                  className={`flex-1 text-center py-2 rounded-lg cursor-pointer transition-all text-sm font-medium ${
                    formData.selectedOption === option.value
                      ? "bg-white dark:bg-slate-600 text-indigo-600 dark:text-indigo-300 shadow-sm"
                      : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
                  } ${edit ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  <input
                    type="radio"
                    value={option.value}
                    checked={formData.selectedOption === option.value}
                    onChange={handleChange}
                    name="selectedOption"
                    disabled={edit}
                    className="hidden"
                  />
                  {option.label}
                </label>
              ))}
            </div>

            {/* Treatment Select */}
            {formData.selectedOption !== "option1" && (
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                  Select Treatment
                </label>
                <select
                  onChange={handleChange}
                  value={formData.treatmentid}
                  name="treatmentid"
                  disabled={edit}
                  className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-50 text-slate-800 dark:text-slate-200"
                >
                  <option value="">Select</option>
                  {(() => {
                    const list = data?.filter((item: any) => item.status1 === true) || [];
                    const others = list.filter((item: any) => (item.treatment === "Others" || item.treatment === "others"));
                    const rest = list.filter((item: any) => item.treatment !== "Others" && item.treatment !== "others");
                    rest.sort((a: any, b: any) => (a.treatment || "").localeCompare(b.treatment || ""));
                    const sorted = [...rest, ...others];
                    return sorted.map((item: any, i: number) => (
                      <option key={i} value={item._id}>{item.treatment}</option>
                    ));
                  })()}
                </select>
              </div>
            )}

            {/* Type Select */}
            {formData.selectedOption === "option3" && (
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                  Select Type
                </label>
                <select
                  onChange={handleChange}
                  value={formData.typeId}
                  name="typeId"
                  disabled={edit}
                  className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-50 text-slate-800 dark:text-slate-200"
                >
                  <option value="">Select</option>
                  {data
                    ?.filter(
                      (item: any) =>
                        item._id === formData.treatmentid && item.status1 === true
                    )
                    .map((filteredItem: any) => filteredItem.type)
                    ?.flat()
                    ?.filter((items: any) => items.status2 === true)
                    .map((item: any, i: number) => (
                      <option key={i} value={item._id}>
                        {item.treatment}
                      </option>
                    ))}
                </select>
              </div>
            )}

            {/* Treatment Name */}
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                Treatment Name <span className="text-red-500 dark:text-red-400">*</span>
              </label>
              <input
                type="text"
                onChange={handleChange}
                value={formData.treatment}
                name="treatment"
                disabled={edit}
                placeholder="Enter treatment name"
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-50 text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
              />
              {formData.treatment === "" && error && (
                <p className="mt-1 text-sm text-red-500 dark:text-red-400">Treatment name is mandatory</p>
              )}
              {formData.treatment.includes("/") && errorslash && (
                <p className="mt-1 text-sm text-red-500 dark:text-red-400">Do not include "/"</p>
              )}
              {errorOthersCase && (
                <p className="mt-1 text-sm text-red-500 dark:text-red-400">Use camelCase: &quot;others&quot;</p>
              )}
            </div>

            {/* Price */}
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                <div className="flex items-center gap-1">
                  <AttachMoneyIcon sx={{ fontSize: 16 }} />
                  Price
                  {formData.treatment === "others" && (
                    <span className="text-xs font-normal text-slate-500 dark:text-slate-400 ml-1">(set at appointment)</span>
                  )}
                </div>
              </label>
              <input
                type="number"
                onChange={handleChange}
                value={formData.treatment === "others" ? 0 : formData.price}
                name="price"
                disabled={formData.treatment === "others"}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-60 disabled:cursor-not-allowed text-slate-800 dark:text-slate-200"
              />
            </div>

            {/* Material Cost */}
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                Material Cost
              </label>
              <input
                type="number"
                onChange={handleChange}
                value={formData.materialCost}
                name="materialCost"
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200"
              />
            </div>

            {/* Doctor Commission (Default) */}
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                <div className="flex items-center gap-1">
                  <PercentIcon sx={{ fontSize: 14 }} />
                  Doctor Commission (Default)
                </div>
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="number"
                  onChange={handleChange}
                  value={formData.doctorCommission}
                  name="doctorCommission"
                  className="flex-1 px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200"
                />
                <div className="px-4 py-2.5 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 rounded-xl font-semibold min-w-[100px] text-center">
                  = {commissionAmount.toFixed(2)}
                </div>
              </div>
            </div>

            {/* Commission by Dentist */}
            {dentists.length > 0 && (
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                  Commission by Dentist
                </label>
                <div className="space-y-2 max-h-40 overflow-y-auto rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-700/50 p-2">
                  {dentists.map((dentist: any) => {
                    const override = formData.doctorCommissionOverrides.find((o) => o.dentistId === dentist._id);
                    const value = override !== undefined ? override.commission : "";
                    const effectivePrice = formData.treatment === "others" ? 0 : formData.price;
                    const dentCommissionAmount =
                      typeof value === "number"
                        ? (effectivePrice - formData.materialCost) * (value / 100)
                        : commissionAmount;
                    return (
                      <div key={dentist._id} className="flex items-center gap-2">
                        <span className="text-sm text-slate-600 dark:text-slate-400 min-w-[120px] truncate">
                          {dentist.title || dentist.firstName} {dentist.lastName || ""}
                        </span>
                        <input
                          type="number"
                          name={`dentistCommission_${dentist._id}`}
                          value={value}
                          onChange={handleChange}
                          placeholder={`${formData.doctorCommission}% default`}
                          className="flex-1 px-3 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
                        />
                        <span className="text-xs text-emerald-600 dark:text-emerald-400 font-medium w-16 text-right">
                          = {typeof value === "number" ? dentCommissionAmount.toFixed(2) : "-"}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="px-6 py-4 bg-slate-50 dark:bg-slate-700/50 border-t border-slate-100 dark:border-slate-600 flex justify-end gap-3 sticky bottom-0">
            <button
              type="button"
              onClick={() => close(false)}
              className="px-5 py-2.5 text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-600 border border-slate-200 dark:border-slate-500 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-500 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-5 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-xl hover:shadow-lg hover:shadow-primary/20 transition-all font-medium"
            >
              {edit ? "Update" : "Add Treatment"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddTreatmentOne;
